/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

interface NotificationDropdownState {
  isModalVisible: boolean;
  unreadNotificationCount: number;
}

const initialState: NotificationDropdownState = {
  isModalVisible: false,
  unreadNotificationCount: 0,
};

export const notificationDropdownSlice = createSlice({
  name: 'notificationDropdown',
  initialState,
  reducers: {
    toggleIsNotificationModalVisible: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.isModalVisible = action.payload;
    },
    setUnreadNotificationCount: (state) => {
      state.unreadNotificationCount += 1;
    },
    setUnreadNotificationCountToZero: (state) => {
      state.unreadNotificationCount = 0;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  toggleIsNotificationModalVisible,
  setUnreadNotificationCount,
  setUnreadNotificationCountToZero,
} = notificationDropdownSlice.actions;

export default notificationDropdownSlice.reducer;
